import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";

function Scan() {
  const [payload, setPayload] = useState([]);
  const [orders, setOrders] = useState([]);
  const [service, setService] = useState(null);
  const [leistung, setLeistung] = useState(null);
  const [translationLanguage, setTranslationLanguage] = useState(null);
  const [translationText, setTranslationText] = useState(null);
  const [recordData, setRecordData] = useState({});
  const [error, setError] = useState(false);
  const [bestellungSucess, setBestellungSucess] = useState(false);
  const [reklamationSuccess, setReklamationSuccess] = useState(false);
  const history = useHistory();
  const [file, setFile] = useState(null);

  const { id } = useParams();

  async function getData() {
    const anlage = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/dropdownOption/${id}`
    );
    setPayload(anlage.data);
  }

  async function register(e) {
    e.preventDefault();
    try {
      recordData["service"] = service._id;
      recordData["project"] = service.project;
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/new-qr-code`,
        recordData,
        {}
      );
      setBestellungSucess(true);
      setTimeout(() => {
        history.go();
      }, 5000);
    } catch (err) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 5000);
    }
  }

  async function translate(languageKey, text) {
    try {
      console.log("KEY: ", translationLanguage);
      if (translationLanguage !== "DE") {
        const translationRes = await axios.post(
          `${process.env.REACT_APP_BACKEND}/services/translate`,
          { languageKey, text },
          {}
        );

        console.log(translationRes.data);
        setTranslationText(translationRes.data.text);
      }
    } catch (err) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 5000);
    }
  }

  async function getOrders(serviceId) {
    try {
      const updatedOrder = await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/reklamieren/${serviceId}`,
        {}
      );
      setOrders(updatedOrder.data);
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  async function reklamationSubmit() {
    try {
      const formData = new FormData();
      formData.append("file", document.getElementById("filePicker").files[0]);
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/upload-file/order/${recordData.reklamation_order}`,
        formData
      );

      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/reklamierenSubmit/${recordData.reklamation_order}`,
        {
          reklamation_status: "offen",
          reklamation_comment: recordData.reklamation_comment,
          reklamation_date: new Date(),
          reklamiert_von: recordData.reklamiert_von,
          status: "reklamiert",
        }
      );

      setReklamationSuccess(true);
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="min-h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-4">
          <div>
            <h3 className=" text-center text-xl font-bold text-gray-900">
              {!service && payload && payload[0] && payload[0].anlage.name}
              {leistung && leistung}
              {service &&
                !leistung &&
                service.pos_nr + " - " + service.pos_name}
            </h3>
            <h4 className="mt-6 text-center text-large font-bold text-gray-900">
              {leistung && service.pos_nr + " - " + service.pos_name}
            </h4>
          </div>

          {!service && (
            <form className="mt-8 space-y-6">
              <div className="col-span-6">
                <label className="block text-center text-sm font-medium text-gray-700">
                  Bitte wähle die gewünschte Leistung
                </label>
              </div>
              <div className=" overflow-hidden sm:rounded-md">
                <div className="text-center px-4 py-5 bg-white sm:p-6">
                  <ul>
                    {payload &&
                      payload.map((service) => (
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              setService(service);
                              getOrders(service._id);
                            }}
                            className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                          >
                            {service.pos_nr + " - " + service.pos_name}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </form>
          )}
          {service && !leistung && (
            <form className="mt-8 space-y-6">
              <div className="col-span-6">
                <label className="block text-center text-sm font-medium text-gray-700">
                  Bitte wähle die gewünschte Leistung
                </label>
              </div>
              <div className=" overflow-hidden sm:rounded-md">
                <div className="text-center px-4 py-5 bg-white sm:p-6">
                  <ul>
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          setLeistung("Information");
                        }}
                        className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                      >
                        Informationen
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          setLeistung("Reklamation");
                        }}
                        className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                      >
                        Reklamation
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          setLeistung("Bestellung");
                        }}
                        className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border  rounded-md shadow-sm text-base font-medium my-2 border-indigo-600"
                      >
                        Bestellung
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          )}
          {service && leistung === "Information" && (
            <form className="mt-2 space-y-2">
              <div className="col-span-6">
                <label className="block text-center font-bold text-sm font-large text-gray-900">
                  Leistungsbeschreibung / Anleitung:
                </label>
              </div>
              <div className=" overflow-hidden sm:rounded-md">
                <div className="text-center px-1 bg-white sm:p-6">
                  <div className="col-span-3 mb-2">
                    <select
                      onChange={(e) => {
                        translate(
                          e.target.value,
                          service.leistungsbeschreibung_lang
                        );
                        setTranslationLanguage(e.target.value);
                      }}
                      value={translationLanguage}
                      className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                      <option value="DE">Übersetzung wählen...</option>
                      <option value="en-GB">English</option>
                      <option value="TR">Turkish</option>
                    </select>
                  </div>
                  {!translationLanguage && service.leistungsbeschreibung_lang}
                  {translationLanguage && translationText}
                </div>
              </div>
              <label className="block text-center pt-4 font-bold text-sm font-large text-gray-900">
                Dateianhänge:
              </label>
              <ul className="mx-5 text-center">
                {service.attachments.map((url) => (
                  <a href={url} target="_blank">
                    <li>{url.split("/")[5]} </li>
                  </a>
                ))}
              </ul>
            </form>
          )}
          {service && leistung === "Bestellung" && (
            <form onSubmit={register} className="mt-2 space-y-2">
              <div className="col-span-6">
                <label className="block text-center font-bold text-sm font-large text-gray-900">
                  Leistung beauftragen:
                </label>
              </div>
              <div className="col-span-2 py-4">
                <label className="block text-sm font-medium text-gray-700">
                  Bestelldatum
                </label>
                <input
                  type="date"
                  required="true"
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      orderDate: e.target.value,
                    })
                  }
                  value={recordData.orderDate}
                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Auftraggeber (Name)
                </label>
                <input
                  type="text"
                  required
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      createdBy: e.target.value,
                    })
                  }
                  value={recordData.createdBy}
                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                />
              </div>
              <div className="col-span-2">
                <label class="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    class="sr-only peer"
                    onChange={(e) =>
                      setRecordData({
                        ...recordData,
                        nachtschicht: e.target.checked,
                      })
                    }
                  />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  <span class="ms-3 text-sm font-medium text-gray-700">
                    Nachtschicht?
                  </span>
                </label>
              </div>
              <div className="col-span-2 py-4">
                <label className="block text-sm font-medium text-gray-700">
                  Kommentar (optional)
                </label>
                <input
                  type="text"
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      comment: e.target.value,
                    })
                  }
                  value={recordData.comment}
                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                />
              </div>
              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Speichern
              </button>
              {bestellungSucess && (
                <div
                  className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                  role="alert"
                >
                  <p>Bestellung erfolgreich gespeichert!</p>
                </div>
              )}
              {error && (
                <div
                  className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                  role="alert"
                >
                  <svg
                    className="fill-current w-6 h-6 mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                  </svg>
                  <p>
                    Fehler beim speichern. Bitte wenden Sie sich an einen
                    Administrator.
                  </p>
                </div>
              )}
            </form>
          )}
          {service && leistung === "Reklamation" && (
            <form onSubmit={reklamationSubmit} className="mt-2 space-y-2">
              <div className="col-span-6">
                <label className="block text-center font-bold text-sm font-large text-gray-900">
                  Bestellung reklamieren
                </label>
              </div>

              <div className="col-span-2 py-4">
                <label className="block text-sm font-medium text-gray-700">
                  Betroffene Bestellung
                </label>
                <select
                  required="true"
                  id="owner"
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      reklamation_order: e.target.value,
                    })
                  }
                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="">Bitte auswählen...</option>
                  {orders.map((option) => (
                    <option value={option._id}>
                      {moment(new Date(option.orderDate)).format("DD.MM.YY")}{" "}
                      (erledigt am{" "}
                      {moment(new Date(option.orderDoneDate)).format(
                        "DD.MM.YY"
                      )}
                      )
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-2 py-4">
                <label className="block text-sm font-medium text-gray-700">
                  Kommentar (optional)
                </label>
                <input
                  type="text"
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      reklamation_comment: e.target.value,
                    })
                  }
                  value={recordData.reklamation_comment}
                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700">
                  Auftraggeber (Name)
                </label>
                <input
                  type="text"
                  required
                  onChange={(e) =>
                    setRecordData({
                      ...recordData,
                      reklamiert_von: e.target.value,
                    })
                  }
                  value={recordData.reklamiert_von}
                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                />
              </div>
              <div class="mt-2">
                <input
                  //equired
                  type="file"
                  name="upload"
                  id="filePicker"
                  accept=".pdf, image/*"
                  onChange={(e) => setFile(e.target.files)}
                />
              </div>

              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Speichern
              </button>
              {reklamationSuccess && (
                <div
                  className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                  role="alert"
                >
                  <p>Reklamation erfolgreich gespeichert!</p>
                </div>
              )}
              {error && (
                <div
                  className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                  role="alert"
                >
                  <svg
                    className="fill-current w-6 h-6 mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                  </svg>
                  <p>
                    Fehler beim speichern. Bitte wenden Sie sich an einen
                    Administrator.
                  </p>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default Scan;
